<template>
  <div>
    200
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "HealthCheck",
  components: {
  },
  mounted(){
  }
};
</script>
